export default "__VITE_ASSET__D7_ueR3D__"